import axios from '../../../helpers/axios';
import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import { QUERY_KEYS } from '../../../queries/query.keys';
import { useTranslation } from 'react-i18next';
import { useSetRecoilState } from 'recoil';
import { notificationState } from '../../../recoil/notification.atom';
import { ICustomerCategoryType } from '../interfaces/customerCategoryType';
import { ROUTE_PATHS } from '../../../config/routes';

export const useMutateCustomerCategoryType = () => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const history = useHistory();
    const setNotification = useSetRecoilState(notificationState);

    const create = useMutation<AxiosResponse, AxiosError, ICustomerCategoryType>(
        (data: ICustomerCategoryType) => axios.post(`customer-category-type`, data),
        {
            onSuccess: async (res) => {
                setNotification({
                    open: true,
                    severity: 'success',
                    message: t('CUSTOMER_CATEGORIES.CREATE_SUCCESS')
                });
                history.push(`${ROUTE_PATHS.CUSTOMER_CATEGORY_TYPES}/${res?.data}`);
                return res;
            },
            onError: (err) => {
                console.error(err.request.response);
                setNotification({ open: true, severity: 'error', message: t('CUSTOMER_CATEGORIES.CREATE_ERROR') });
            },
            onSettled: async () => {
                await queryClient.invalidateQueries(QUERY_KEYS.MANDATOR_LIST);
            }
        }
    );

    const update = useMutation<AxiosResponse, AxiosError, ICustomerCategoryType>(
        (data: ICustomerCategoryType) => axios.put(`customer-category-type/${data.id}`, data),
        {
            onSuccess: async (res) =>
                setNotification({
                    open: true,
                    severity: 'success',
                    message: t('CUSTOMER_CATEGORIES.UPDATE_SUCCESS')
                }),
            onError: (err) => {
                console.error(err.request.response);
                setNotification({ open: true, severity: 'error', message: t('CUSTOMER_CATEGORIES.UPDATE_ERROR') });
            },
            onSettled: async () => {
                await queryClient.invalidateQueries(QUERY_KEYS.MANDATOR_LIST);
            }
        }
    );

    const remove = useMutation<AxiosResponse, AxiosError, ICustomerCategoryType>(
        (data: ICustomerCategoryType) => axios.delete(`customer-category-type/${data.id}`),
        {
            onSuccess: async (res) =>
                setNotification({
                    open: true,
                    severity: 'success',
                    message: t('CUSTOMER_CATEGORIES.DELETE_SUCCESS')
                }),
            onError: (err) => {
                console.error(err.request.response);
                setNotification({ open: true, severity: 'error', message: t('CUSTOMER_CATEGORIES.DELETE_ERROR') });
            },
            onSettled: async () => {
                await queryClient.invalidateQueries(QUERY_KEYS.MANDATOR_LIST);
            }
        }
    );

    return { update, create, remove };
};
